import {useReducers, UseReducersReturnValue} from '@wallaby-ui/core';
import {useRef} from 'react';

import {getReducers} from 'src/js/containers/reports/reports_reducers';

export function useReportReducers(reportId: string): UseReducersReturnValue {
  const reducersRef = useRef<Record<string, any>>(getReducers(reportId));

  return useReducers(reducersRef.current);
}
